export const burgerMenuStyles = {
    bmMenuWrap: {
        position: 'fixed',
            // height: '90%',
            width: '50%',
        // left:'0',
    }
}
